import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.truncated-brief-view': {
    backgroundColor: COLORS.WHITE,
    height: '100%',
    flex: 1,
    overflowY: 'scroll',
    '.truncated-brief-view__heading p': {
      height: '32px',
      marginBottom: theme.space[4],
      fontSize: theme.fontSizes[5],
    },
  },
  '.truncated-brief-view': {
    '&__content': {
      padding: theme.space[4],
    },
    '&__hr': {
      margin: `${theme.space[6]} 0`,
    },
    '&__banner': {
      marginBottom: theme.space[4],
    },
    '&__pricing-label': {
      fontWeight: 600,
    },
    '&__pricing-details': {
      marginBottom: 0,
    },
    '&__module-label': {
      marginBottom: 0,
    },
    '&__module-order-label': {
      fontWeight: 600,
      marginRight: theme.space[1],
    },
    '&__module-file-list': {
      marginBottom: '20px',
    },
    '&__button': {
      margin: theme.space[4],
      width: `calc(100% - ${theme.space[8]})`,
    },
  },
});
